// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"445":"8fa7153a","485":"de2eee95","865":"ee066fa2"}[chunkId] + ".css";
};